/**
 * Tipo de persona (física o jurídica) deducido del NIF.
 *
 * Módulo compartido entre cliente y servidor. Se importa SIEMPRE con ruta
 * relativa desde `functions/` (tsc no reescribe `@shared`).
 */

/** F = persona física, J = persona jurídica (PersonTypeCode de Facturae). */
export type TipoPersona = "F" | "J";

/**
 * Deduce el tipo de persona por la forma del NIF:
 * - DNI (8 dígitos + letra), NIE (X/Y/Z + 7 dígitos + letra) y NIF especiales
 *   de personas físicas (K/L/M + 7 dígitos + control) → "F".
 * - CIF (letra de organización + 7 dígitos + control) → "J".
 * - Cualquier otra cosa → null.
 *
 * Solo mira la forma, no el dígito de control: un NIF mal escrito no debe
 * impedir deducir el tipo (la validez se comprueba aparte).
 */
export function inferirTipoPersona(nif: string | null | undefined): TipoPersona | null {
  const limpio = String(nif ?? "").toUpperCase().replace(/[\s-]/g, "");

  if (/^\d{8}[A-Z]$/.test(limpio)) return "F"; // DNI
  if (/^[XYZ]\d{7}[A-Z]$/.test(limpio)) return "F"; // NIE
  if (/^[KLM]\d{7}[A-Z0-9]$/.test(limpio)) return "F"; // NIF especial de persona física
  if (/^[ABCDEFGHJNPQRSUVW]\d{7}[A-Z0-9]$/.test(limpio)) return "J"; // CIF

  return null;
}
